import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';
import App from './routes/App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import { inicializarTema } from './functions/theme';
import { registrarPWA } from './pwa';

inicializarTema();

// Habilita instalar la app y detecta cuándo hay una versión nueva. Va antes del
// render para no perderse el evento beforeinstallprompt, que Chrome dispara
// temprano y una sola vez. Cuando hay update NO recarga solo: muestra un cartel
// (AvisoActualizacion) para que la persona actualice cuando quiera, sin
// interrumpirla ni sacarla de la sesión.
registrarPWA();

const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);


reportWebVitals();
